import { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function InactiveUsersReportTable() {

  const navigate = useNavigate();
  const [rows] = useState([
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      lastLogin: "12-Jul-2025 09:15 AM",
      inactiveDays: 55,
      status: "Inactive",
    },
    {
      id: 2,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      lastLogin: "05-Jun-2025 04:25 PM",
      inactiveDays: 92,
      status: "Inactive",
    },
    {
      id: 3,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      lastLogin: "20-May-2025 11:00 AM",
      inactiveDays: 110,
      status: "Inactive",
    },
  ]);

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow hover>
            <TableCell>User</TableCell>
            <TableCell>Last Login</TableCell>
            <TableCell>Inactive Since (Days)</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow hover key={row.id}>
              <TableCell>
                <Box
                  component="a"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/manage-users/detail");
                  }}
                  className="user_block click_action"
                >
                  <p>
                    <b>{row.name}</b>
                    <span>{row.email}</span>
                    <span>{row.phone}</span>
                  </p>
                </Box>
              </TableCell>
              <TableCell>{row.lastLogin}</TableCell>
              <TableCell>{row.inactiveDays}</TableCell>
              <TableCell>
                <span className="status_btn c_danger">
                  {row.status}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
